import { useMemo } from 'react';
import styled, { useTheme } from 'foundations-theming-specialty/utils';
import { View } from 'foundations-components/transitional/components/View';
// @ts-expect-error untyped external dependency
import MarkdownIt from 'markdown-it';
import { CODE_BLOCK_REGEX } from 'chatspot-core/messages/code/CodeRegex';
import Markdown from './text/Markdown';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledMarkdown = styled.div.withConfig({
  displayName: "MarkdownSectionFormatter__StyledMarkdown",
  componentId: "sc-1aefdt2-0"
})(["font-size:", ";p,ul{margin-bottom:", ";}a{color:", ";font-size:", " !important;}a:hover{color:", ";}h1{font-size:", ";margin-bottom:", ";}h2{font-size:", ";margin-bottom:", ";}h3{font-size:", ";margin-bottom:", ";}h4{font-size:", ";margin-bottom:", ";}h5{font-size:", ";margin-bottom:", ";}"], ({
  $fontSize
}) => $fontSize, ({
  theme
}) => theme.space['100'], ({
  theme
}) => theme.color['breeze-text-badge-default'], ({
  theme
}) => theme.typography['body-100'].fontSize, ({
  theme
}) => theme.color['breeze-fill-primary-hover'], ({
  theme
}) => theme.typography['body-400'].fontSize, ({
  theme
}) => theme.space['250'], ({
  theme
}) => theme.typography['body-300'].fontSize, ({
  theme
}) => theme.space['250'], ({
  theme
}) => theme.typography['body-200'].fontSize, ({
  theme
}) => theme.space['200'], ({
  theme
}) => theme.typography['body-125'].fontSize, ({
  theme
}) => theme.space['200'], ({
  theme
}) => theme.typography['body-100'].fontSize, ({
  theme
}) => theme.space['200']);

// Initialize MarkdownIt instance with options
const md = new MarkdownIt({
  html: true,
  // Allow HTML tags in source
  xhtmlOut: false,
  // Use '/' to close single tags (<br />)
  breaks: true,
  // Convert '\n' in paragraphs into <br>
  linkify: true,
  // Autoconvert URL-like text to links
  typographer: true,
  // Enable smartquotes and other typographic replacements
  highlight: null // Disable syntax highlighting by default
});
const MarkdownSectionFormatter = ({
  section: {
    text = ''
  },
  shouldShowTypingIndicator,
  typography
}) => {
  const theme = useTheme();
  const fontSize = typography ? theme.typography[typography].fontSize : theme.typography['detail-100'].fontSize;
  const messageBlocks = useMemo(() => {
    const textBlocks = text.split(CODE_BLOCK_REGEX);
    return textBlocks.map((textBlock, index) => {
      // Use MarkdownIt to render the markdown content
      const renderedHtml = md.render(textBlock);
      return /*#__PURE__*/_jsx(StyledMarkdown, {
        $fontSize: fontSize,
        children: /*#__PURE__*/_jsx(Markdown, {
          html: renderedHtml,
          showTypingIndicator: shouldShowTypingIndicator && index === textBlocks.length - 1
        })
      }, index);
    });
  }, [shouldShowTypingIndicator, text, fontSize]);
  return /*#__PURE__*/_jsx(View, {
    overflow: "auto",
    inlineSize: "100%",
    children: messageBlocks
  });
};
export default MarkdownSectionFormatter;